<template>
  <div class="product-item-step-bd clear product-protocal">
    <div class="product-protocal-info">
      <!-- 协议列表 -->
      <protocol
        :productSn="productSn"
      ></protocol>
      <!-- topic列表 -->
      <!-- <topic
        ref="topic"
        :protocol-id="curProtocol.protocolId"
        :product-id="productId"
        :topic-class="topicClass"
        :product-code="productCode"
        :tsl-version="curProtocol.tslVersion"
        :is-publish="curProtocol.isPublish"
      ></topic> -->
    </div>
    <div class="footer">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="onBack">{{
        $t('dms_product_item_step_protocol.sybcpcs')
      }}</el-button>
      <el-button
        type="primary"
        @click="onFinish"
      >{{
        $t('Common.com_finish')
      }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import protocol from './protocol_component_protocol.vue';

export default {
  props: {
    productId: [Number, String],
    productCode: String,
    productSn: [Number, String],
  },
  components: {
    protocol,
  },
  data() {
    return {
      productDetail: {},
      curProtocol: {},
      topicClass: []
    };
  },
  mounted: function () {
    this.getTopicClass();
  },
  methods: {
    onFinish() {
      this.$router.back();
    },
    onEditTopic(row) {
      if (this.curProtocol.protocolId === row.protocolId) {
        this.$refs.topic.update();
      }
    },
    onDeleteTopic(row) {
      if (this.curProtocol.protocolId === row.protocolId) {
        this.curProtocol = {};
      }
    },
    onPublishTopic(row) {
      if (this.curProtocol.protocolId === row.protocolId) {
        this.curProtocol.isPublish = 1;
      }
    },
    onCancelPublish(row) {
      if (this.curProtocol.protocolId === row.protocolId) {
        this.curProtocol.isPublish = 0;
      }
    },
    getTopicClass() {
      this.getDictionary('iot_topic_class', (data) => {
        this.topicClass = data.iot_topic_class;
      });
    },
    onRowClick(row) {
      this.curProtocol = row;
      this.$nextTick(() => {
        this.$refs.topic.getTableList();
      });
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 返回
    onBack: function () {
      this.$emit('back');
    },
    // 下一步
    onStep: function () {
      this.$emit('step', { name: 'protocol' });
    },
    async getProductDetail() {
      return this.$getJSON(apis.ProductInfoDetail, {
        productId: this.productId
      }).then(res => res.data);
    },
    async init() {
      // const productDetail = await this.getProductDetail();
      // this.productDetail = productDetail;
    }
  }
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
</style>
